import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Props } from './NoPlanPermissionProps.types.tsx';

const LazyNoPlanPermissionErrorPage = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-arj-no-plan-permission", jiraPriority: 'ondemand' */ './NoPlanPermissionErrorPage.tsx'
		),
);

export const AsyncNoPlanPermissionErrorPage = (props: Props): React.JSX.Element => (
	<Placeholder name="arj-no-plan-permission" fallback={<Spinner />}>
		<LazyNoPlanPermissionErrorPage {...props} />
	</Placeholder>
);
